import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { Alert } from '@decisiv/ui-components';
import { declaredMetadataProperties } from '../../utils/actionMetadataSchema';

// Explains the metadata keys the bound action declares via its
// metadata_schema. Rendered next to the generic metadata editor, where those
// keys are pre-seeded; renders nothing when the action declares none.
export default function ActionMetadataNotice({ metadataSchema = null }) {
  const declared = declaredMetadataProperties(metadataSchema);
  if (declared.length === 0) return null;

  return (
    <Alert intent="information" title={t`Action metadata keys`}>
      <Trans>
        This action expects the metadata keys below. They are pre-filled in the
        metadata editor — renaming or removing them can hide information in the
        apps that consume this integration.
      </Trans>
      {declared.map(({ key, description }) => (
        <React.Fragment key={key}>
          <br />
          <code>{key}</code>
          {description && <> — {description}</>}
        </React.Fragment>
      ))}
    </Alert>
  );
}
ActionMetadataNotice.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  metadataSchema: PropTypes.object,
};
